import { render, staticRenderFns } from "./doDiningList.vue?vue&type=template&id=be5b84d6&scoped=true"
import script from "./doDiningList.vue?vue&type=script&lang=js"
export * from "./doDiningList.vue?vue&type=script&lang=js"
import style0 from "./doDiningList.vue?vue&type=style&index=0&id=be5b84d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5b84d6",
  null
  
)

export default component.exports